module.exports = __webpack_public_path__ + "static/media/tools.9ab37d65.jpg";